var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"datePickerReadonlyInput",class:[
    { 'datePickerReadonlyInput--focus': _vm.focus },
    'datePickerReadonlyInput--' + _vm.align
  ],attrs:{"type":"text","readonly":"","placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }